<template>
  <div class="d-flex">
    <div v-for="(item, index) in days" :key="index" class="d-flex align-center">
      <v-btn
        :id="item.domElementId + domElementIdProp"
        icon
        :color="item.selected ? 'blue' : ''"
        @click="addDays(item)"
        :class="!disable ? 'disable-events' : ''"
      >
        <v-icon
          >mdi-alpha-{{ item.day }}{{ item.selected ? '-circle' : '' }}</v-icon
        >
      </v-btn>
    </div>
    <div class="d-flex align-end" v-if="disable">
      <v-checkbox
        :id="`idEventosTodosLosDias${domElementIdProp}`"
        v-model="activeEveryDay"
        class="shrink"
        :label="
          $t('fleet_management.agents.create.labels.create_days_every_day')
        "
        @change="everyDay"
      ></v-checkbox>
    </div>
  </div>
</template>

<script>
import Dialog from '../../dialog/Dialog.vue'
export default {
  components: { Dialog },
  props: {
    idRestrictions: {
      type: String
    },
    edit: {
      type: Array
    },
    disable: {
      type: Boolean
    },
    domElementIdProp: {
      type: Number
    }
  },
  data() {
    return {
      activeEveryDay: false,
      days: [
        { day: 'l', value: '1', selected: false, domElementId: 'idEventosLunes' },
        { day: 'm', value: '2', selected: false, domElementId: 'idEventosMartes' },
        { day: 'm', value: '3', selected: false, domElementId: 'idEventosMiercoles' },
        { day: 'j', value: '4', selected: false, domElementId: 'idEventosJueves' },
        { day: 'v', value: '5', selected: false, domElementId: 'idEventosViernes' },
        { day: 's', value: '6', selected: false, domElementId: 'idEventosSabado' },
        { day: 'd', value: '0', selected: false, domElementId: 'idEventosDomingo' }
      ]
    }
  },
  methods: {
    daysSelected() {
      const days = this.days.filter(e => e.selected === true)
      const selected = { days: days, id: this.idRestrictions }
      this.$emit('timeDays', selected)
    },
    addDays(item) {
      item.selected = !item.selected
      this.activeEveryDay = false
      this.daysSelected()
    },
    everyDay(value) {
      this.days = this.days.map(e => {
        e.selected = value
        return e
      })
      this.daysSelected()
    },
    editSelected() {
      if (this.edit) {
        this.days.map(day => {
          this.edit.some(edit =>
            edit.value === day.value
              ? (day.selected = edit.selected)
              : day.selected
          )
        })
      }
      if (this.edit.length === 7) this.activeEveryDay = true
    }
  },
  mounted() {
    if (!this.disable) this.editSelected()
    this.daysSelected()
  }
}
</script>

<style>
.disable-events {
  pointer-events: none;
}
</style>
